import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { privateHealthSchema } from '@flows/configs/de/privateHealth/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface PrivateHealthStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  environment: string
  platform: 'web' | 'native'
}

export const employmentSchema = z.object({
  products: z.object({
    mga_private_health_de: z.object({
      configuration_parameters: privateHealthSchema.pick({
        employment_status: true,
      }),
    }),
  }),
})

export const incomeSchema = z.object({
  products: z.object({
    mga_private_health_de: z.object({
      configuration_parameters: privateHealthSchema.pick({
        income: true,
      }),
    }),
  }),
})

export const insuranceTypeSchema = z.object({
  products: z.object({
    mga_private_health_de: z.object({
      configuration_parameters: privateHealthSchema.pick({
        insurance_type: true,
      }),
    }),
  }),
})

export const ineligibleStatusSchema = z.object({})

export const successSchema = z.object({})
